<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">
      <div class="bg-default m-b-30">
        <div class="container">
          <div class="row p-b-60 p-t-60">
            <div
              class="col-md-6 text-center mx-auto text-white p-b-30 spacer-image"
            >
              <button @click="printMe" class="btn btn-outline-info">
                Print
              </button>
            </div>
          </div>
        </div>
      </div>
      <section class="">
        <div class="container">
          <div class="row list"></div>

          <div class="row col-md-12">
            <div class="col-md-8 " id="printDiv" ref="printNow">
              <div
                class="card"
                style="
                  background-image: url('/assets/img/zamfara_transparent.png');
                  background-size: cover;
                  background-repeat: no-repeat;
                "
              >
                <div class="card-header">
                  <div class="row">
                    <!-- <div class="col-md-2">
                       
                      </div> -->
                    <div class="col-md-8">
                      <!-- <div class="col-md-12">
                        <span class="avatar avatar-xl">
                          <img
                            :src="`https://claimify-api.hayokmedicare.ng/image/${agency.user_image}`"
                            class="rounded"
                          />
                        </span>
                      </div> -->

                      <div class="h1 text-info mt-8">
                        {{ agency.agency_name }}
                      </div>
                    </div>

                    <div class="col-md-4">
                      <img
                        :src="`${client.user.image_url}`"
                        class="img spacer-top rounded"
                        onerror="this.onerror=null; this.src='/assets/img/placeholder.svg'"
                      />
                    </div>
                  </div>
                </div>

                <div class="card-body col-md-12">
                  <div class="row h4">
                    <div class="col-md-4">
                      <strong class="text-info">Gender: </strong>
                      <p>{{ client.user.gender }}</p>
                    </div>
                    <div class="form-group col-md-4">
                      <strong class="text-info">Blood Group: </strong>
                      <p>{{ client.user.blood_group }}</p>
                    </div>

                    <div class="col-md-4">
                      <strong class="text-info"></strong>
                      <p>{{ client.user.full_name }}</p>
                    </div>
                  </div>

                  <div class="col-md-12 text-center h4 mt-6">
                    <strong class="text-info"
                      >{{ agency.firstname }} ID:
                    </strong>
                    <p>{{ client.user.id_card_number }}</p>
                  </div>

                  <div class="form-row h4 mt-8">
                    <div class="form-group col-md-4">
                      <strong class="text-info"> Date of Birth </strong>
                      <p>{{ client.user.dob }}</p>
                    </div>

                    <div class="form-group col-md-4">
                      <strong class="text-info">Date of Issue </strong>

                      <p>{{ date_id_card_issued }}</p>
                    </div>

                    <div class="form-group col-md-4">
                      <strong class="text-info">Establishment</strong>
                      <p v-if="client.user.place_of_work != null">
                        {{ client.user.place_of_work }}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-8 offet-md-2 my-4">
            <div class="card m-b-30">
              <div class="card-body">
                <div class="form-group">
                  <p class="my-4">
                    <b class="text-danger">HMO Code:</b> <span v-if="client.tpa && client.tpa.tpa_id">{{ client.tpa.tpa_id }}</span>
                  </p>

                  <p><b class="text-danger">HMO:</b> <span v-if="client.tpa && client.tpa.organization_name">{{ client.tpa.organization_name }}</span></p>
                </div>

                <hr />

                <div class="col-md-12 m-b-30">
                  <div class="table-responsive">
                    <table class="table align-td-middle table-card">
                      <thead>
                        <tr class="text-danger">
                          <th>DEPENDENTS</th>
                          <th>GENDER</th>
                          <th>DOB</th>
                          <th>ZAMCHEMA NO.</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="dependent in dependents"
                          v-bind:key="dependent.id"
                        >
                          <td>
                            <span class="font-bold">
                              {{ dependent.firstname }}
                              {{ dependent.middlename }}
                              {{ dependent.lastname }}
                            </span>
                          </td>
                          <td>{{ dependent.gender }}</td>

                          <td>
                            {{ dependent.dob }}
                          </td>
                          <td>
                            {{ dependent.id_card_number }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="row col-md-12">
                  <div class="col-md-8">
                    <p class="text-danger">This card is the property of the Zamfara State Contributory Healthcare Management
                    Agency (ZAMCHEMA). If found, please return to the nearest ZAMCHEMA office or health facility.
                    </p>
                  </div>

                  <div class="col-md-4">
                    <p>
                      <b> Authorized Signature:</b>
                      .....................................
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="vld-parent">
          <loading
            :active.sync="isLoading"
            loader="dots"
            :can-cancel="true"
            :is-full-page="fullPage"
          ></loading>
        </div>
      </section>
    </main>
  </section>
</template>
  
  <script>
import Navbar from "@/views/Navbar.vue";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin
// import { WebCam } from "vue-web-cam";
let agency = JSON.parse(localStorage.getItem("agency"));
import moment from "moment";
moment().format();

export default {
  components: {
    Navbar,
    Loading,
  },
  data() {
    return {
      agency: agency,
      user: null,
      trx_image: false,
      auth_user: "",
      client: "",
      trx_doc: null,
      notes: "",
      dependents: "",
      medications: "",
      healthFacility: "",
      date_id_card_issued: moment().format("YYYY-MM-DD"),
      signature: "",
      enrolled_by: "",
      singleward: "",
      singlelga: "",
      edit: false,
      isLoading: false,
      fullPage: true,
      transactionID: "",
      agency_id: "",
      imagefile: "",
      image: "",
      paymentProofFile: "",
      paymentProofImage: "",
      output: "",
      singletpa: "",
      trxdocclass: "col-md-4",
      trxtableclass: "col-md-12",
      pictureShower: true,

      transaction_ref_length: 50,
    };
  },

  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.axios
      .get(`/api/v1/auth/user/zam/${this.$route.params.id}`)
      .then((response) => {
        this.client = response.data;
        console.log(response);
      })
      .catch((error) => {
        console.error(error);
      });
  },

  methods: {
    async print() {
      const el = this.$refs.printNow;

      const options = {
        type: "dataURL",
      };
      this.output = await this.$html2canvas(el, options);
    },

    printMe() {
      let printContents = document.getElementById("printDiv").innerHTML;
      let originalContents = document.body.innerHTML;
      document.body.innerHTML = printContents;
      window.print();
      document.body.innerHTML = originalContents;
    },

    fetchUser() {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.axios
        .get(`/api/v1/auth/user/zam/${this.$route.params.id}`)
        .then((response) => {
          this.client = response.data;
          this.dependents = response.data.dependents;

          //get dependents
          this.axios
            .post(`/api/v1/auth/allDependantsUser`, {
              agency_id: agency.id,
              id_card_number: this.client.id_card_number,
              user_id: this.$route.params.id,
            })
            .then((response) => {
              console.log(response);
            })
            .catch((error) => {
              console.error(error);
            });
          //end of get dependents
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
  created() {
    this.fetchUser();
  },
};
</script>
  <style scoped>
.spacer {
  margin-left: 1px;
  margin-top: 5px;
  margin-bottom: 5px;
}
.spacer-image {
  margin-top: 25px;
}
.spacer-top-bottom {
  margin-top: 10px;
  margin-bottom: 10px;
}
.spacer-top {
  margin-top: 50px;
}
#container {
  margin: 0px auto;
  width: 500px;
  height: 375px;
  border: 10px #333 solid;
}
#videoElement {
  width: 500px;
  height: 375px;
  background-color: #666;
}
th {
  text-align: center;
}

td {
  width: fit-content;
  text-align: center;
}

.payment__proof {
  width: 20%;
}

.payment__proof,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: inline-block;
}
</style>
  